<template>
    <div class="chips-container" :class="{stacked}">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "chips-container",
        props: {
            stacked: {type: Boolean, default: false}
        }
    }
</script>

<style lang="scss">
    @import "./chips-container";
</style>